import script from "./MyFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./MyFiles.vue?vue&type=script&setup=true&lang=js"

import "./MyFiles.vue?vue&type=style&index=0&id=07146814&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07146814"]])

export default __exports__